module.exports = __webpack_public_path__ + "img/73_15.fec5f192.png";